import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sensors-page" }
const _hoisted_2 = { class: "sensors-page__header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Title, {
        title: _ctx.$t('sensors')
      }, null, 8, ["title"])
    ]),
    _createVNode(_component_Tabs, {
      tabs: _ctx.tabs,
      onSelectTab: _ctx.setActiveTab
    }, null, 8, ["tabs", "onSelectTab"]),
    _createVNode(_component_router_view)
  ]))
}